import { SET_USER, CLEAR_USER } from "../types";
// import { getDecodedToken, getAccessToken } from "utils/helper";

const initialState = {
  user: JSON.parse(localStorage.getItem("current_user") || null) || null,
};

const user = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_USER:
      return { user: payload };

    case CLEAR_USER:
      return { user: null };
    default:
      return state;
  }
};

export default user;
